var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm"
  }, [_c('v-row', {
    staticClass: "row--xl",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-sheet', {
    staticClass: "d-inline-block rounded-pill py-2 px-4 px-md-6"
  }, [_c('div', {
    staticClass: "txt txt--lg primary--text font-weight-bold"
  }, [_vm._v("20년 바이오 제조 전문기업과 성장할 기회!")])]), _c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit white--text mt-4"
  }, [_c('div', {
    staticClass: "tit--lg"
  }, [_vm._v("리본바이옴과 함께할 파트너 모집")]), _c('div', {
    staticClass: "tit--xl"
  }, [_vm._v("지금 가입하고 혜택을 받아보세요!")])])]), _c('p', {
    staticClass: "txt txt--lg white--text"
  }, [_vm._v(" 리본바이옴은 국내 파트너의 자체 브랜드 상품뿐만 아니라, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 리본바이옴 완제품에 대해서도 해외 수출 활용이 가능하도록 서포트합니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 필요 시 영문 라벨, 패키지, 수출 전용 CoA, 성분표, HS 코드 자료 등을 제공해드리며, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 자체 유통은 물론 B2B 수출 목적으로도 활용할 수 있습니다. ")]), _c('div', {
    staticClass: "btn-wrap btn-wrap--lg"
  }, [_c('v-btn', {
    attrs: {
      "to": "/partner",
      "min-width": "150",
      "x-large": ""
    }
  }, [_vm._v("파트너 등록하기")])], 1)], 1), _c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/main/recruitment.png",
      "alt": "",
      "max-width": "646"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }